import _ from 'lodash';

import {
  removeNonDigits
} from './form/normalization';
// temp solution to change json respons prop case to camelCase (e,g, Name => name)
//export const cleanJSONProps = obj => _.mapKeys(obj, (v, k) => _.camelCase(k));

export const cleanJsonInResponse = (response) => {
  return JSON.parse(JSON.stringify(response), (key, value) => {
    if (value && typeof value === 'object')
      for (let k in value) {
        if (/^[A-Z]/.test(k) && Object.hasOwnProperty.call(value, k)) {
          value[k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
          delete value[k];
        }
      }
      return value;
    });
};

// converts camelCase to CONSTANT_CASE
export const camelToConstant = (str) => str.replace(/\W+/g, '_').replace(/([a-z\d])([A-Z])/g, '$1_$2').toUpperCase();

const creditCardRegex = {
  visa: new RegExp('^4[0-9]{0,15}$'),
  mastercard: new RegExp('^5$|^5[1-5][0-9]{0,14}$'),
  amex: new RegExp('^3$|^3[47][0-9]{0,13}$'),
  discover: new RegExp('^6$|^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$')
};

// return an array of card types that matches the passed card number
export const detectCreditCard = (number) => Object.keys(creditCardRegex).filter(type => number && removeNonDigits(number).match(creditCardRegex[type]));

export const priceToString = (amount={dollars:'0', cents: '00'}) => `$${amount.dollars}.${amount.cents}`;

//https://gist.github.com/penguinboy/762197
export const flattenObject = (ob) => {
	const toReturn = {};

	for (const i in ob) {
		if (!ob.hasOwnProperty(i)) continue;

		if ((typeof ob[i]) == 'object') {
			const flatObject = flattenObject(ob[i]);

			for (const x in flatObject) {
				if (!flatObject.hasOwnProperty(x)) continue;

				toReturn[`${i}.${x}`] = flatObject[x];
			}
		} else {
			toReturn[i] = ob[i];
		}
	}
	return toReturn;
};

// http://stackoverflow.com/questions/12539574/whats-the-best-way-most-efficient-to-turn-all-the-keys-of-an-object-to-lower
export const lowerObj = obj => {
  return _.transform(obj, function (result, val, key) {
    result[key.toLowerCase()] = val;
  });
};

// Array map function that works with yield keyword
export const mapGen = function* (arr, callback, thisArg) {
  let T, A, k;

  if (arr == null) {
    throw new TypeError('this is null or not defined');
  }

  let O = Object(arr);
  let len = O.length >>> 0;

  if (typeof callback !== 'function') {
    throw new TypeError(`${callback} is not a function`);
  }

  if (arguments.length > 1) {
    T = thisArg;
  }

  A = new Array(len);

  k = 0;

  while (k < len) {
    let kValue, mappedValue;

    if (k in O) {
      kValue = O[k];
      mappedValue = yield callback.call(T, kValue, k, O);
      A[k] = mappedValue;
    }
    k++;
  }
  return A;
};

// useful for keeping urls uniform
export const noEndingSlash = text => {
  return text[text.length - 1] === '/'
    ? text.slice(0, -1)
    : text;
};

export const findInString = (string, substring) => {
  if (typeof string !== 'string' && typeof substring !== 'string') {
    return false;
  } else {
    return string.toLowerCase().indexOf(substring) > -1;
  }
};

export const areAllObjPropsFalsy = (items) => _.reduce(items, function(result, value) {
  return value ? !!value : result;
}, false);

// objectContainsNonEmptyArrays({ a: [], b: ["item"], c: [] })  returns true
// objectContainsNonEmptyArrays({ a: [], b: [], c: [] })        returns false
export const objectContainsNonEmptyArrays = object => _.some(Object.keys(object), key => object[key].length > 0);



/** WEBPACK FOOTER **
 ** ./client/util/helpers.js
 **/